import React, { useEffect, useState } from 'react';
import { contactInfoApi } from '../api'; 
import './AdminPhone.css'; 

const AdminPhone = () => {
    const [currentPhone, setCurrentPhone] = useState('');
    const [newPhone, setNewPhone] = useState('');
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        fetchCurrentPhone();
    }, []);

    const fetchCurrentPhone = async () => {
        try {
            const res = await contactInfoApi.get(); 
            const phoneValue = res.data?.phone || 'No phone number set.';
            setCurrentPhone(phoneValue);
            setNewPhone('');
        } catch (err) {
            console.error('Error fetching phone:', err);
            setCurrentPhone('Error loading phone number.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newPhone.trim()) {
            return alert("Please enter a valid phone number.");
        }

        setLoading(true);
        try {
            await contactInfoApi.update(newPhone.trim());
            alert('✅ Contact phone number updated successfully!');
            fetchCurrentPhone();
        } catch (err) {
            console.error('Update failed:', err);
            alert('❌ Failed to update phone number.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-phone-wrapper">
            <div className="admin-panel-header">
                <div className="panel-title-group">
                    <i className="fas fa-phone-alt title-icon"></i>
                    <div>
                        <h2>Contact Phone Number</h2>
                        <p className="panel-subtitle">Official chapter telephone / WhatsApp number displayed in the footer</p>
                    </div>
                </div>
            </div>

            <div className="phone-management-grid">
                <div className="current-phone-card">
                    <span className="card-badge-label">Active Contact Line</span>
                    <div className="phone-display-box">
                        <div className="phone-icon-pill">
                            <i className="fas fa-phone-volume"></i>
                        </div>
                        <span className="active-phone-digits">{currentPhone}</span>
                    </div>
                </div>

                <div className="update-phone-card">
                    <form className="admin-glass-form" onSubmit={handleSubmit}>
                        <div className="admin-form-group">
                            <label>Update Phone Number</label>
                            <input
                                type="text"
                                placeholder="+91 99667 98059"
                                value={newPhone}
                                onChange={(e) => setNewPhone(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="admin-btn-primary" disabled={loading}>
                            {loading ? (
                                <>
                                    <i className="fas fa-circle-notch fa-spin"></i> Saving...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-save"></i> Save Phone Number
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminPhone;